import * as Configuration from '../app.constants.js';

reloadLatestClientRun.$inject = ['$rootScope', '$state', '$cookies', 'LoginFactory'];
export function reloadLatestClientRun($rootScope, $state, $cookies, LoginFactory) {

  $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams, options) {
    if (LoginFactory.shouldReloadLatestClient()) {

      // Ceinture et bretelles: let's not reload more often than once per 5 minutes
      // just in case there is a bug that triggers an infinite loop of reloads
      const lastReloadTimeMillis = getLastReloadTime();
      if (typeof lastReloadTimeMillis != 'number' || lastReloadTimeMillis + (5 * 60 * 1000) < Date.now()) {

        setLastReloadCookie();
        window.location.href = Configuration.constants.frontendBaseUrl + $state.href(toState, toParams);
        window.location.reload();
      } else {
        // We only reload after a login or a SSO connection
        LoginFactory.clearShouldReloadLatestClient();
      }
    }
  });

  const LAST_RELOAD_COOKIE_NAME = 'alcmeon-last-reload-time';

  // use cookie instead of localstorage for storing reload time 
  // because the tiniest innocent 403 error will clear localstorage
  function setLastReloadCookie() {
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    $cookies.putObject(LAST_RELOAD_COOKIE_NAME, Date.now(), {
      path: '/',
      expires: expiryDate
    });
  }

  function getLastReloadTime() {
    return $cookies.getObject(LAST_RELOAD_COOKIE_NAME);
  }

}